import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';

import {orcidLink} from '../../helpers/links';
import HighlightedItem from '../atoms/HighlightedItem';


class OrcidId extends React.Component {
    constructor(props) {
        super(props);
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    orcidItem = () => {
        return (
            <span>
                <Link target="_blank" rel="noreferrer" onClick={this.stopPropagation}
                    href={orcidLink(this.props.orcid_id.id)}>{this.props.orcid_id.id}</Link>
            </span>
        );
    };

    render() {
        return (
            <HighlightedItem stats={this.props.stats} contentCallback={this.orcidItem} />
        );
    }

}

OrcidId.propTypes = {
    orcid_id: PropTypes.object.isRequired,
    stats: PropTypes.object
};

export default OrcidId;
